import { LoginFailed, LoginForm } from '../../view/login-form/login-form';
import styles from './login-page.module.css';

export function LoginPage({ lang, failed, onLogin, onFailClose, disabled, initUserName } : {
    lang: string
    failed: boolean
    onLogin: (user: string, password: string) => void
    onFailClose: () => void
    disabled: boolean
    initUserName?: () => string
}) {

    return <>
        <div className={`${styles.loginFormContainer} ${failed ? styles.hidden : ''}`}>
            <LoginForm lang={lang} onLogin={onLogin} disabled={disabled} initUserName={initUserName}/>
        </div>
        {
            failed ? 
                <div className={styles.loginFormContainer}>
                    <LoginFailed lang={lang} onClose={onFailClose} />
                </div>
                :
                null
        }
    </>
}